import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=2879464a&scoped=true&"
import script from "./comment.vue?vue&type=script&lang=js&"
export * from "./comment.vue?vue&type=script&lang=js&"
import style0 from "./comment.vue?vue&type=style&index=0&id=2879464a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../tmp/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2879464a",
  null
  
)

export default component.exports